import { useI18n } from "@/i18n/I18nProvider";

const REGIONS = [
    { name: "Marche", state: "active" },
    { name: "Umbria", state: "coming" },
    { name: "Abruzzo", state: "coming" },
    { name: "Toscana", state: "coming" },
];

export default function RegionTicker() {
    const { t } = useI18n();
    return (
        <div
            data-testid="region-ticker"
            style={{
                background: "var(--itly-teal-900)",
                color: "var(--itly-on-teal)",
                padding: "18px 0",
                overflow: "hidden",
                position: "relative",
            }}
        >
            <div className="itly-ticker-track">
                {/* List is duplicated for the seamless marquee loop: name+index is a stable key */}
                {[...REGIONS, ...REGIONS].map((r, i) => (
                    <span
                        key={`${r.name}-${i}`}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 10,
                            padding: "0 22px",
                            fontFamily: "Fraunces, serif",
                            fontSize: 20,
                            letterSpacing: "-0.01em",
                            color: r.state === "active" ? "var(--itly-orange-500)" : "rgba(247,244,238,0.7)",
                        }}
                    >
                        {r.state === "active" ? (
                            <span
                                aria-hidden="true"
                                style={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: 999,
                                    background: "var(--itly-orange-500)",
                                    boxShadow: "0 0 0 4px rgba(232,113,76,0.24)",
                                }}
                            />
                        ) : (
                            <span aria-hidden="true" style={{ color: "rgba(247,244,238,0.35)", fontSize: 14 }}>✦</span>
                        )}
                        {r.name}
                        {r.state === "coming" && (
                            <span
                                style={{
                                    fontFamily: "Inter, sans-serif",
                                    fontSize: 11,
                                    letterSpacing: "0.14em",
                                    textTransform: "uppercase",
                                    color: "rgba(247,244,238,0.4)",
                                    fontWeight: 700,
                                    padding: "3px 8px",
                                    border: "1px solid rgba(247,244,238,0.14)",
                                    borderRadius: 999,
                                    marginLeft: 2,
                                }}
                            >
                                {t("ticker.coming")}
                            </span>
                        )}
                    </span>
                ))}
            </div>
        </div>
    );
}
